module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick-6c44b45d5cd8d1ee43b43c2aaa75f419.png";